/* © NXAPP Limited */
import { Link } from 'react-router-dom'

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-2xl mx-auto space-y-6">
        <h1 className="text-2xl font-bold text-gray-900">Terms of Use</h1>
        <p className="text-sm text-gray-500">Last updated: July 2026 · NXAPP Limited</p>
        <div className="prose prose-sm text-gray-700 space-y-4">
          <p>
            NXAPP Bulletin is a proprietary newsletter platform operated by NXAPP Limited.
            Access is restricted to authorised administrators only.
          </p>
          <p>
            You agree to use this platform solely for legitimate email marketing to contacts who
            have opted in under UK GDPR / PECR requirements. You are responsible for maintaining
            a lawful basis for processing subscriber data.
          </p>
          <p>
            NXAPP Limited reserves the right to suspend access for misuse, including sending spam,
            violating anti-spam laws, or breaching these terms.
          </p>
          <p>
            For questions contact <a href="mailto:legal@nxapp.co.uk" className="text-brand-600">legal@nxapp.co.uk</a>.
          </p>
        </div>
        <Link to="/login" className="text-sm text-brand-600 hover:underline">← Back to login</Link>
      </div>
    </div>
  )
}
